export { default } from './Earnings';


